import React, { ReactElement } from "react";
import { normalizeToIdFormat } from "../../utils";
import { ToolbarItemProps } from "../components/toolbar-item.types";

export const toolbarItemsParser = (
  items: React.ReactNode[] | null,
  textButtons: boolean
): ToolbarItemProps[] => {
  let toolbarElements: ToolbarItemProps[] | null = null;

  if (items !== null) {
    toolbarElements = items
      .filter((item): item is ReactElement => React.isValidElement(item))
      .filter((item) => {
        const itemType: any = item.type;
        return itemType?.displayName === "ToolbarItem";
      })
      .map((item) => item.props);
  }

  let hasCustomOrder = false;

  const parsedToolbarElements: ToolbarItemProps[] = (toolbarElements || []).map(
    (item, i) => {
      hasCustomOrder = item.order !== undefined || hasCustomOrder;

      const {
        label,
        order = i + 1,
        priority = 0,
        id,
        _privateProps,
        children,
      } = item;

      return {
        label,
        order,
        priority,
        id: id || normalizeToIdFormat(label),
        _privateProps: {
          visible: true,
          hasChildren: !!children,
          textButton: textButtons,
          ..._privateProps,
        },
      };
    }
  );

  // For performance reasons, we only sort the schema when a custom order is used
  return hasCustomOrder
    ? parsedToolbarElements.sort(
        (a, b) => (a.order as number) - (b.order as number)
      )
    : parsedToolbarElements;
};
